function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { FieldBase } from "./FieldBase";
import { InputField } from "./InputField";
/** @jsx jsx */

import { jsx } from "@emotion/react";
import PropTypes from "prop-types";
import React from "react";
import * as Datetime from "react-datetime";
import "./DateTimeField.css";
import "react-datetime/css/react-datetime.css";
import "../Resources/datetime-picker.css"; // #region HOOK

/**
 * Représente un champ de saisie de type date/heure
 * @class
 * @category Fields
 * @param {Fields.DateTimeField.propTypes} props Les propriétés du composant
 */

function DateTimeField(props) {
  // Récupération des props
  var backgroundColor = props.backgroundColor,
      format = props.format,
      name = props.name,
      onChange = props.onChange,
      placeholder = props.placeholder,
      readonly = props.readonly,
      textColor = props.textColor,
      tooltip = props.tooltip,
      value = props.value; // Fonction appelée lors du changement de valeur

  var internalHandleChange = function internalHandleChange(param, name) {
    if (typeof param === "string") {
      // Date invalide, on la passe quand même pour ne pas effacer le champ
      if (onChange) {
        onChange(name, param);
      }

      return;
    } // Date valide, param est un objet moment


    if (onChange) {
      onChange(name, param.format(format));
    }
  };

  return jsx(React.Fragment, null, readonly ? jsx(InputField, props) : jsx(FieldBase, _extends({}, props, {
    render: function render() {
      return jsx(Datetime, {
        closeOnSelect: true,
        css: {
          width: "100%"
        },
        inputProps: {
          className: "DateTimeField",
          placeholder: placeholder ? placeholder : tooltip,
          style: {
            backgroundColor: backgroundColor,
            color: textColor,
            width: "100%"
          }
        },
        onChange: function onChange(param) {
          return internalHandleChange(param, name);
        },
        value: value
      });
    }
  })));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link DateTimeField}
 * @typedef {Object} DateTimeField.propTypes
 * @property {string} name Le nom du champ
 * @property {string} tooltip Le descriptif du champ et par défaut le placeholder
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [backgroundColor=#fff] La couleur de fond
 * @property {string} [textColor=#000] La couleur du texte
 * @property {string} [value] La date sélectionnée
 * @property {string} [icon=null] L'icône à afficher
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {boolean} [obligatory=false] true si le champ est obligatoire
 * @property {boolean} [readonly=false] true si le champ est désactivé
 * @property {boolean} [alert=false] true si l'on veut afficher une icône d'alerte
 * @property {boolean} [msgAlert=""] Message d'alerte à afficher quand alert vaut true
 * @property {string} [placeholder=null] Par défaut le placeholder vaut _tooltip_, mais on peut le surcharger grâce à cette propriété
 * @property {number} [offset=0] Valeur du offset à appliquer si le composant est dans un scroll panel
 */


DateTimeField.propTypes = process.env.NODE_ENV !== "production" ? {
  format: PropTypes.string,
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  value: PropTypes.string,
  icon: PropTypes.string,
  keepSpaceIcon: PropTypes.bool,
  obligatory: PropTypes.bool,
  readonly: PropTypes.bool,
  alert: PropTypes.bool,
  msgAlert: PropTypes.string,
  placeholder: PropTypes.string,
  offset: PropTypes.number
} : {};
/*
  Valeurs par défaut des propriétés
*/

DateTimeField.defaultProps = {
  format: "YYYY-MM-DDTHH:mm:ss.SSSZ",
  width: "100%",
  backgroundColor: "#fff",
  textColor: "#000",
  value: "",
  icon: null,
  keepSpaceIcon: false,
  obligatory: false,
  readonly: false,
  alert: false,
  msgAlert: "",
  placeholder: null,
  offset: 0
}; // #endregion

export { DateTimeField };